import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import styled, { css } from 'styled-components';
import { CalendarIcon } from '@deliveryhero/armor-icons';
import { borderRadius, color, spacing, typography, zIndex, propsBlocker, getComponentOverride, focusWithin } from '@deliveryhero/armor-system';
import { TextInput } from '@deliveryhero/armor';
export var getRootStyle = function getRootStyle(_ref) {
  var enableTimePicker = _ref.enableTimePicker,
    enableMinWidthAutoCorrection = _ref.enableMinWidthAutoCorrection;
  var result = {};
  if (enableMinWidthAutoCorrection !== false) {
    result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            min-width: ", ";\n        "])), spacing(enableTimePicker ? 88 : 58));
  }
  return result;
};
export var DatePickerInput = styled(TextInput)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    width: 100%;\n"])), function (_ref2) {
  var disabled = _ref2.disabled,
    error = _ref2.error;
  return focusWithin({
    disabled: disabled,
    error: error,
    noOutline: true
  });
});
export var DatePickerInputIcon = styled(CalendarIcon).attrs({
  small: true
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-right: ", ";\n\n    // todo: fix this\n    && {\n        color: ", ";\n    }\n"])), spacing(2), color('primary.main'));
export var DatePickerDropdown = styled.div.withConfig(propsBlocker)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    border-radius: ", ";\n    background-color: ", ";\n    min-width: ", ";\n    ", ";\n    ", ";\n    overflow: hidden;\n\n    box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.12);\n"])), typography('paragraphMedium'), color('neutral.07'), borderRadius('round'), color('neutral.00'), spacing(84), zIndex, getComponentOverride('DatePickerDropdown'));
// we have to keep the arrow, even though it is not in the design
// if we don't have it, the popper library screws everything up
export var DatePickerDropdownArrow = styled.div.withConfig(propsBlocker)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    height: 0;\n    width: 0;\n    visibility: hidden;\n"])));